import { Types } from "@grandvisionhq/stores-v2";
const fromAvailabilityStoresNearbyQueryToStore = (queryData) => {
  if (!queryData || queryData.availability.length === 0) {
    return null;
  }
  try {
    return queryData.availability.map((entry) => {
      const { streetNumber, postalCode, province, distance, hearingAppointmentPossible } = entry.store;
      const { slotsAvailable, nextAvailableBookingDate } = entry;
      const accessibility = entry.store.accessibility || [];
      return {
        slotsAvailable,
        nextAvailableBookingDate: nextAvailableBookingDate ? new Date(nextAvailableBookingDate) : void 0,
        store: {
          ...entry.store,
          streetNumber: streetNumber ?? void 0,
          postalCode: postalCode ?? void 0,
          province: province ?? void 0,
          distance: distance ?? void 0,
          appointmentTypes: [],
          wheelchairAccessible: accessibility.includes(Types.ACCESSIBILITY_WHEELCHAIR),
          hearingAppointmentPossible: Boolean(hearingAppointmentPossible)
        }
      };
    });
  } catch (e) {
    console.error(
      "fromAvailabilityStoresNearbyQueryToStore data adapter failed to parse input data correctly.",
      e,
      queryData
    );
    return null;
  }
};
export {
  fromAvailabilityStoresNearbyQueryToStore as default,
  fromAvailabilityStoresNearbyQueryToStore
};
//# sourceMappingURL=fromAvailabilityStoresNearbyQueryToStore.js.map
